const location = window.location;
// const TMPURL = process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_API;
const TMPURL = process.env.NODE_ENV === 'development' ? '/api' : location.origin;
// const TMPURL = process.env.NODE_ENV === 'development' ? 'https://other.yingxiong.com/cd-auto/10.22.200.199:8087' : location.origin;

export {
  TMPURL
};